import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFeedback } from "../service/axiosInstance";
import $ from "jquery";
import "slick-carousel";

const Testimonial = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";
  const imagealt = "image";

  const { t } = useTranslation();

  const [isSliderInitialized, setIsSliderInitialized] = useState(false);

  const sliderRef = useRef(null);

  const [data, setData] = useState([]);
  console.log(data);

  const getFeedbackData = async () => {
    try {
      const resp = await getFeedback({
        page: 1,
        limit: 9,
      });
      setData(resp?.data?.feedback);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFeedbackData();

    const $slider = $(sliderRef.current);

    const initializeSlider = () => {
      if ($slider && $slider.length && data.length > 0) {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }

        $slider.slick({
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 2,
          prevArrow:
            '<a class="slick-prev"><i class="fas fa-arrow-left"></i></a>',
          nextArrow:
            '<a class="slick-next"><i class="fas fa-arrow-right"></i></a>',
          responsive: [
            {
              breakpoint: 1800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 575,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
      setIsSliderInitialized(true);
    };

    if (data.length > 0) {
      initializeSlider();
    }

    return () => {
      if ($slider && $slider.hasClass("slick-initialized")) {
        // $slider.slick("unslick");
      }
      setIsSliderInitialized(false);
    };
  }, [data.length, isSliderInitialized]);

  return (
    <div
      className="ltn__testimonial-area section-bg-1--- bg-image-top pt-115 pb-70"
      data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                Our Testimonial
              </h6>
              <h1 className="section-title">{t("client")}</h1>
            </div>
          </div>
        </div>
        <div
          className="row ltn__testimonial-slider-5-active slick-arrow-1"
          ref={sliderRef}
        >
          {
            // [
            //   {
            //     feedback: `${t("feedback1")}`,
            //   },
            //   {
            //     feedback: `${t("feedback2")}`,
            //   },
            //   {
            //     feedback: `${t("feedback3")}`,
            //   },
            //   {
            //     feedback: `${t("feedback4")}`,
            //   },
            // ]
            data &&
              data?.map((testimonial, index) => (
                <div className="col-lg-4" key={index}>
                  <div
                    className="ltn__testimonial-item ltn__testimonial-item-7"
                    style={{ minHeight: "350px" }}
                  >
                    <div className="ltn__testimoni-info">
                      <p>
                        <i className="flaticon-left-quote-1" />{" "}
                        {testimonial?.text}
                      </p>
                    </div>
                  </div>
                </div>
              ))
          }
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
